<div class="mt-5">
  <a (click)="showDocument()">
    <i antIcon type="file-pdf" theme="outline"></i>&nbsp;<span appTranslate="documents.central"></span>
  </a>
</div>
